import clsx from "clsx";

import CheckIcon from "../svg/CheckIcon.tsx";

import styles from "./FeaturesList.module.css";

// TODO: Very similar to Trial Timeline component, revise and remove duplicates
export const FeaturesList = () => {
  return <>
    <p className={clsx("caption-sm", styles.captionMigiriIncludes)}>
      THIS IS WHAT MIGIRI INCLUDES:
    </p>
    <ul>
      <li>
        <CheckIcon className={styles.listIcon} />A powerful porn blocker
        with the ability to block custom sites
      </li>
      <li>
        <CheckIcon className={styles.listIcon} />A progress counter with
        awards for achieving milestones
      </li>
      <li>
        <CheckIcon className={styles.listIcon} />
        Guidance and tools to avoid relapsing
      </li>
      <li>
        <CheckIcon className={styles.listIcon} />
        Access to a growing library of content resources - from
        meditations to workouts and more!
      </li>
      <li>
        <CheckIcon className={styles.listIcon} />
        The option to add an accountability partner to support your
        journey
      </li>
      <li>
        <CheckIcon className={styles.listIcon} />A single subscription
        covers all your Apple & Android devices
      </li>
    </ul>
  </>
}